import { render, staticRenderFns } from "./TabCommitments.vue?vue&type=template&id=69a2a74e"
import script from "./TabCommitments.vue?vue&type=script&lang=js"
export * from "./TabCommitments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports